/**
 * @desc 导入SKU物流属性模板下载
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/logisticsSku/downloadImportTemp`, {
      method: "GET",

      ...options,
    }),
  );
}
